import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { getThemeCompareSelectedValue } from "../../../reducer/patientCompareSlice";

function CompareLegend(props) {
    const themeCompare = useSelector(getThemeCompareSelectedValue);
    // const populationValue = useSelector(getPopulationRate);

    return (
        <>
            <div style={{
                position: 'relative'
            }}>
                <Typography sx={{ 
                    fontSize: 12, 
                    textAlign: 'left',
                    fontWeight: '400',
                }}>
                    จำนวนผู้ป่วยเทียบ (m = มัธยฐาน 5 ปี)
                </Typography>
                <Grid container spacing={0}>
                {
                    themeCompare.map((data, index) => {
                        return (
                            <Grid key={index} item xs={(12/themeCompare.length)}>
                                <div style={{
                                    height: 20,
                                    backgroundColor: data.color,
                                    marginTop: '5px'
                                }}></div>
                                <Typography sx={{
                                    fontSize: 10,
                                    textAlign: 'center',
                                    marginTop: '5px',
                                    fontWeight: '400',
                                }}>
                                    {data.legend}
                                </Typography>
                            </Grid>
                        )
                    })
                }
                </Grid>
            </div>
        </>
    )
}

export default CompareLegend;